<template>
  <div>
    <card-tags :selected="select_tag" :tags="tags" @changeSelect="newValue => select_tag=newValue">
      <template slot="all">
        {{$I18n("all")}}
      </template>
      <template slot="pending">
        {{$I18n("pending")}}
      </template>
    </card-tags>
      <md-card class="full-window-card had-tags">
        <!-- 卡片-主体 -->
        <md-card-content>
          <div class="md-layout" style="flex-wrap: nowrap;flex-direction: column; margin: -15px -20px;max-width: 320px; min-width: 300px; ">
            <!-- 第一步骤 -->
            <div>
              <p>import operation</p>
              <div style="display: flex; align-items: center;">
                <div style="line-height: 38px;flex-grow: 1;">
                  ①Template Download:
                </div>
                <div>
                  <md-button class="diy-blue small" @click="() => importMember = true">
                    <img src="/img/haiqora/import/upload-cloud.svg" height="20" />
                    {{$I18n("import")}}
                  </md-button>
                </div>
              </div>
            </div>
            <!-- 第三步骤 -->
            <div class="md-layout-item" style="padding-left: 0;padding-right: 0;background: #edf4ff;padding: 10px;">
              <!-- 筛选-Input -->
              <div style="position: relative;">
                <common-form-item 
                  style="margin-bottom: 16px;"
                  :labelweight="100"
                  v-model="tree_filter" 
                  type="input"
                  placeholder=""
                />
                <md-icon class="search-icon">search</md-icon>
              </div>
              <tree
                ref="tree"
                node-key="_id"
                :props="treeDefaultProps"
                :data="deptData"
                @node-collapse="closeExpd"
                @node-expand="openExpd"
                :default-expanded-keys="defaultExpd"
                :filter-node-method="filterNode"
              >
                <div class="custom-tree-node diy-tree-node" slot-scope="{ data }" :class="{
                  'selected-tree': dept_id === data._id,
                }" @click="(event) => changeTree(data, event)">
                  <span 
                    v-if="data.children && data.children.length > 0"
                    :ref="'tree_'+data._id"
                    @click="(event) => expandedTree(data, event)"
                    class="el-tree-node__expand-icon el-icon-caret-right TTT" 
                    :class="{'expanded': defaultExpd.includes(data._id)}"
                  ></span>
                  <span class="diy-tree-title">{{ data.name }}</span>
                </div>
              </tree>
            </div>
          </div>




          <!-- <div class="search-form">
            <div style="width: 270px;">
              <common-form-item 
                class="border-input-type"
                :labelweight="100"
                v-model="searchForm.req_user_name"
                v-bind="searchTable[0]"
              />
            </div>
            <div style="width: 270px;">
              <common-form-item 
                class="border-input-type"
                :labelweight="100"
                v-model="searchForm.type"
                v-bind="searchTable[1]"
              />
            </div>
            <div style="padding-left: 20px;">
              <md-button @click="goSearch" class="diy-back-blue has-icon left-icon md-info">
                <md-icon>search</md-icon>
                {{$I18n("sure")}}
              </md-button>
              <md-button @click="goReset" class="diy-blue has-icon left-icon slim">
                <md-icon>refresh</md-icon>
                {{$I18n("cancle")}}
              </md-button>
            </div>
          </div> -->
          <!-- <md-table class="diy-gray" v-model="tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }"  md-selectable="single">
              <md-table-cell :md-label="$I18n('gene_appr')">{{item.type_name}}</md-table-cell>
              <md-table-cell :md-label="$I18n('fnd_menber')">{{item.req_user_name}}</md-table-cell>
              <md-table-cell :md-label="$I18n('appl_time')">{{item.create_date}}</md-table-cell>
              <md-table-cell :md-label="$I18n('appr_time')">{{item.update_date}}</md-table-cell>
              <md-table-cell :md-label="$I18n('subject')">{{item.remark}}</md-table-cell>
              <md-table-cell :md-label="$I18n('status')">
                <span v-if="item.state === 1">{{$I18n("unapproved")}}</span>
                <span v-if="item.state === 2" style="color: #00B507;">{{$I18n("appr_pass")}}</span>
                <span v-if="item.state === 3" style="color: #FF0000;">{{$I18n("appr_denied")}}</span>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('mani')" class="button-cell">
                <md-button @click="table_agreeItem(item)" @click.stop class="md-simple md-info">
                  Agree
                </md-button>
                <md-button @click="table_refuseItem(item)" @click.stop class="md-simple md-info">
                  Refuse
                </md-button>
                <md-button @click="table_detailItem(item)" @click.stop class="md-simple md-info ">
                  View Details
                </md-button>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
          </md-table> -->
          <!-- <table-page :total="total" :pageSize="pageSize" @changePage="page => pageSize = page" v-model="currentPage"/> -->
        </md-card-content>
      </md-card>
  </div>
</template>
<script>
import { Tree } from 'element-ui';
export default {
  name:"member-import",
  components: { Tree },
  props:{
    deptData:{
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data(){
    return {
      select_tag: 0,
      tags: ["all", "pending"],
      // Tree 相关参数
        defaultExpd: [], // 默认展开项目
        dept_id : 0,     // 选中部门
        tree_filter: "",
        treeDefaultProps: {  // TREE 默认数据
          children: 'children',
          label: 'label'
        },
    }
  },
  mounted: function(){
    if(this.deptData.length > 0){
      this.dept_id = this.deptData[0]._id
    }
  },
  computed:{
    dept_true_id(){
      if(!this.dept_id){
        return ""
      }
      return this.dept_id.replace("d_","")
    },
  },
  watch:{
    dept_true_id(val){
      console.log(val)
    },
    select_tag(val){
      console.log(val)
    },
    tree_filter(val){
      this.$refs.tree.filter(val);
    },
  },
  methods:{

    // TREE 逻辑相关 
      closeExpd(item){
        this.defaultExpd = this.defaultExpd.filter(i => i !== item._id && !item.children.map(j => j._id).includes(i))
      },
      openExpd(item){
        this.defaultExpd = [...this.defaultExpd, item._id]
      },
      // 点击 树状图 展开
      expandedTree(data, event){
        this.$refs["tree_"+ data._id].parentNode.previousElementSibling.click();
        event.stopPropagation();
      },
      // 点击 树状图 切换
      changeTree(data, event){
        this.dept_id = data._id;
        event.stopPropagation();
        return false
      },
      // 树状图筛选方法
      filterNode(value, data) {
        if (!value||!data) return true;
        return data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
      },
  },
}
</script>
<style scoped>
  .ex-shadow {
    position:absolute; 
    top: 42px;
    bottom: 0;
    left: 0;
    right: 0;
    background: url("/img/haiqora/ex-qr.png");
    background-size: 100% 100%; 
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ex-icon{
    font-size: 45px !important;
    color: #FFFFFF !important;
  }
  /* Label 额外信息 ICON */
  .more-info-span{
    border: 1px solid #578EFF;
    height: 12px;
    width: 12px;
    line-height: 12px;
    color: #578EFF;
    display: inline-block;
    text-align: center;
    border-radius: 50%;
    font-size: 8px;
    font-weight: 800;
    font-style: normal;
  }
  .qrcode-box h4{
    font-size: 16px;
    font-weight: 400;
  }
  .qrcode-box .qr-box{
    width:340px; 
    background: #F2F4F8;
    margin: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .qr-box .qr-info{
    width: 100%;
    background: #E7EAF1;
    text-align: center;
    font-size: 14px;
    line-height: 42px;
  }
  .qr-box .qr-img{
    width: 310px;
    margin: 18px auto 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  /*TREE*/
  .selected-tree .el-tree-node__expand-icon{
    color: #FFF !important;
  }
  /*TREE END*/
  .table-image{
    max-width: 38px;
    max-height: 38px; 
    height: auto; 
    width: auto;
  }
  .custom-tree-node{
    margin-left: -25px;
    height: 30px;
    line-height: 30px;
    padding-left: 6px;
    width: 100%;
  }
  .diy-tree-node{
    padding-right: 30px;
    background: #edf4ff;
  }
  .diy-tree-node .md-icon.md-theme-default.md-icon-font{
    transition: none;
  }
  .diy-tree-node .diy-tree-title{
    margin-left: 4px;
    max-width: calc(100% - 37px);
    position: absolute;
    box-sizing: border-box;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .diy-tree-node.selected-tree {
    background: #578EFF;
    color: #FFF;
  }
  .selected-tree .md-icon.md-theme-default.md-icon-font{
    color: #FFF;
  }
  .search-icon{
    font-size: 18px !important; 
    position: absolute;
    right: 4px;
    top: 2px;
    cursor: pointer;
  }
  .table-button-box button{
    margin-right: 25px;
  }
  .table-form-box{
    display:flex;
    align-items:center;
    flex-wrap: wrap;
  }
  .table-form-box button{
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .table-form-box button:nth-of-type(1){
    margin-right:25px;
  }

  /deep/ .el-tree-node__children, /deep/ .el-tree-node__content{
    background: #edf4ff;
  }
  .diy-blue.small{
    line-height: 28px !important;
    height: 28px !important;
    /*line-height: ;*/
  }
</style>